import { Observable } from 'rxjs';
import { FilterInfos } from 'src/app/models/server/core/filter-infos';
import { Results } from 'src/app/models/server/core/results-T';
import { SortInfos } from 'src/app/models/server/core/sort-infos';
import { Folder } from 'src/app/models/server/folder';

export class BaseDatasource {
    countDatas(): number {
        return null;
    }

    listDatas(from: number, size: number, sort: SortInfos, filters: FilterInfos[], generalFilters: FilterInfos[]): Observable<Results<Folder>> {
        return null;
    }

    exportDatas(sort: SortInfos, filters: FilterInfos[], generalFilters: FilterInfos[]): Observable<Blob> {
        return null;
    }

    isFolderContainsIntoList(folder: Folder): boolean {
        return false;
    }
}
